import React, { Component } from 'react'
import PropTypes from "prop-types";
import { connectIntegration, disconnectIntegration } from '../../redux/actions/integrationsConnectionActions';
import iManageIcon from "./icons/imanage.png";
import iManageAuthenticator from "./iManageAuthenticator";
import {Button, ControlLabel, Form, FormControl, FormGroup, Modal} from "react-bootstrap";

export default class IManageSwitch extends Component {
  static defaultProps = {
    connectionId: null,
  };

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    connectionId: PropTypes.number,
    agreedToPricing: PropTypes.bool.isRequired,
  };

  state = {
    loading: false,
    showServerDialog: false,
    serverName: null,
  };

  onClick = () => {
    const {connectionId} = this.props;

    if (connectionId === null) {
      this.showServerDialog();
      return;
    }
    else {
      return this.props.dispatch(disconnectIntegration(connectionId));
    }
  }

  hideServerDialog = () => {
    this.setState({showServerDialog: false});
  }

  showServerDialog = () => {
    this.setState({showServerDialog: true});
  }

  handleServerNameChange = (event) => {
    this.setState({serverName: event.target.value});
  }

  connectToIManage = () => {
    this.setState({showServerDialog: false, loading: true});

    const {serverName} = this.state;

    // TODO - we should put the server name into the OAuth state
    iManageAuthenticator(serverName)
      .login('imanage', {
        scope: 'user',
        state: { redirect_host: window.location.host, serverName }
      })
      .then(
        ({ authResponse }) => {
          this.props.dispatch(connectIntegration('files', 'imanage', authResponse));

          this.setState({ loading: false });
        },
        (res) => {
          const { code, message } = res.error;

          this.setState({ loading: false });

          notify.error(`Error connecting to iManage: [${code}] ${message || ''}`);
        }
      );
  }

  render() {
    const { connectionId, agreedToPricing } = this.props;
    const iconCls = `kloudless-switch ${connectionId ? 'on' : ''} ${agreedToPricing ? '' : 'hidden'}`;

    return (
      <div className="kloudless-control-holder2" >
        <img className="kloudless-connection-icon"
             src={iManageIcon}
             alt="iManage Logo"
        />

        <div className={iconCls} onClick={this.onClick} >
          { this.state.loading
          && <i
            className={"fa fa-circle-o-notch fa-spin"}
            style={{ marginTop: '10px', marginLeft: '11px', fontSize: '11px' }}
          />}
        </div>

        <Modal show={this.state.showServerDialog} onHide={this.hideServerDialog}>
          <Modal.Header closeButton>
            <Modal.Title>iManage Server Settings</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <FormGroup controlId="formIManageServer">
                <ControlLabel>Enter your iManage Server Name</ControlLabel>
                <FormControl
                  type="text"
                  value={this.state.serverName}
                  placeholder="imanage.yourfirm.com"
                  onChange={this.handleServerNameChange}
                  style={{width: '100%', boxSizing: 'border-box'}}
                />
                <FormControl.Feedback/>
              </FormGroup>
            </Form>
            <Button bsStyle="primary" onClick={this.connectToIManage} disabled={!this.state.serverName}>Connect To iManage</Button>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Integrations/connections/IManageSwitch.jsx